import AbstractGuestlistDetailsPageController from '../guestlists/abstract-details-controller';

export default class GuestlistRsvpsDuplicatesPageController extends AbstractGuestlistDetailsPageController {
    constructor($scope, $injector) {
        super($scope, $injector);


    }

    _handleGuestlistSelect() {
        super._handleGuestlistSelect();
        this.setupStore();
        this.mode = 'listview';
    }

    setupStore() {
        if (this.stateParams.store) {
            this.store = this.stateParams.store;
        } else {
            this.store = this.injector.get('RsvpDuplicates').create(`Guestlist${this.guestlist.id}DuplicatesView`);
            // if (this.store.state.visible.length <= 3) {
            //     this.store.commit('setVisible', [
            //         'contact.first_name',
            //         // 'contact.email'
            //     ]);
            // }
        }

        this.store.dispatch('loadState');
        this.store.commit('setTitle', 'Duplicates on: ' + this.guestlist.name);
        this.store.commit('setVm', this);
        this.store.commit('setPrefix', 'guestlists/' + this.guestlist.id);
        this.store.commit('setDataUrl', 'guestlists/' + this.guestlist.id + '/rsvps/duplicates');

        this.store.dispatch('getDefinitions');

        this.store.resetGetters();

    }

    close() {
        this.mode = 'listview';
    }

    save() {
        const data = {
            fields: {rsvp: this.rsvp, contact: this.contact},
            items: this.store.getters.selectedFilters
        };
        this.api.put(`rsvps`, data)
            .then(() => {
                this.alert.success('Bookings Update', 'The bookings details have successfully been updated');
                this.refresh().then(this.close.bind(this))
            }, err => this.alert.handle(err));

    }

    refresh() {
        return this.api.get(`guestlists/${this.guestlist.id}`)
            .then(response => {
                this.guestlist = response.data.data;
                return this.store.dispatch('getData');
            }, err => {
                this.alert.handle(err);
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/guestlists/controllers/pages/rsvps/duplicates-controller.js